import { Controller } from "@hotwired/stimulus";
import dayjs from "dayjs";

// Connects to data-controller="cally"
export default class extends Controller {
  static targets = ["input", "rangeStart", "rangeEnd", "label", "rangeLabel"];

  static values = {
    format: String,
  };

  connect() {
    this.formatValue = this.formatValue || "YYYY-MM-DD";
  }

  setInputValue(e) {
    this.inputTarget.value = e.target.value;
  }

  setLabelValue(e) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = e.target.value ? dayjs(e.target.value).format(this.formatValue) : "Choose a Date";
    }
  }

  setRangeInputValues(e) {
    this.rangeStartTarget.value = e.target.value.split("/")[0];
    this.rangeEndTarget.value = e.target.value.split("/")[1];
  }

  setRangeLabelValue(e) {
    if (!this.hasRangeLabelTarget) return;

    if (e.target.value) {
      const startDate = e.target.value.split("/")[0];
      const endDate = e.target.value.split("/")[1];
      const days = [...new Set([startDate, endDate])];
      this.rangeLabelTarget.textContent = days.map((day) => dayjs(day).format(this.formatValue)).join(" – ");
    } else {
      this.rangeLabelTarget.textContent = "Choose a Date Range";
    }
  }
}
